import type { Element } from "React";
import { Component } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
type Props = {
  sortingOptions: Record<string, any>;
  bookmarkOnly: boolean;
  favouritesOnly: boolean;
  selectSorting: (...args: Array<any>) => any;
  sortingType: string;
  disabled: boolean;
};

class Sorting extends Component<Props> {
  render(): Element<"div"> {
    const {
      sortingOptions,
      bookmarkOnly,
      selectSorting,
      sortingType,
      favouritesOnly,
      disabled,
    } = this.props;
    return (
      <div className="global-event-navigation--sorting">
        <Dropdown
          id="sorting"
          name="sorting"
          options={sortingOptions}
          className={`navigation-sorting__dropdown ${
            bookmarkOnly || favouritesOnly || disabled ? "disabled" : ""
          }`}
          onChange={e => selectSorting(e)}
          value={sortingType}
        />
      </div>
    );
  }
}

export default Sorting;
